module.exports = __webpack_public_path__ + "static/img/BCNY.e78f105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/BCNY.png
// module id = H+tM
// module chunks = 34